import { render, staticRenderFns } from "./AppUserInviteDialog.vue?vue&type=template&id=4997f1f5&"
import script from "./AppUserInviteDialog.vue?vue&type=script&lang=ts&"
export * from "./AppUserInviteDialog.vue?vue&type=script&lang=ts&"
import style0 from "./AppUserInviteDialog.vue?vue&type=style&index=0&id=4997f1f5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports